import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import { Link } from "react-router-dom";
import P from "../../assets/Parasitic.png";

const ParasiticDraw = () => {
  return (
    <>
      <SeoHead
        title="Parasitic Draw Diagnosis in Temecula | Advanced Automotive Smog"
        description="Parasitic draw testing in Temecula to trace unwanted power drains and repair the cause when your battery keeps dying overnight."
        path="/services/parasitic-draw"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Parasitic Draw Diagnosis"
          path="/services/parasitic-draw"
          description="Parasitic draw testing in Temecula to trace unwanted power drains and repair the cause when your battery keeps dying overnight."
          serviceType="Parasitic draw diagnosis"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
          {/* Image - mobile priority */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={P}
                alt="Parasitic draw diagnosis"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text content */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Electrical Diagnosis
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Parasitic Draw Diagnosis
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              If your battery keeps dying overnight or after short periods of
              parking, you may have a parasitic draw. We trace and repair
              unwanted power drains so your vehicle starts reliably every time.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is Parasitic Draw?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Even when your car is off, some systems draw a small amount of
              power. When a module, accessory, or wiring fault pulls too much
              power, it drains the battery—this is called a parasitic draw.
              <br />
              <br />
              Our technicians use professional test equipment to measure the
              draw, isolate the faulty circuit, and repair the component
              causing the problem.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>
                  Detailed testing to pinpoint hidden{" "}
                  <Link to="/services/battery-replacement" className="text-teal-600 hover:underline">
                    battery drains
                  </Link>
                </span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Repair or replacement of faulty electrical components</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Helps restore normal battery life and performance</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Prevents unexpected no-start situations</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Professional diagnostics for all makes and models</span>
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>
          </div>
        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default ParasiticDraw;

